import { render } from "./FeedbackPage.vue?vue&type=template&id=479b3f93"
import script from "./FeedbackPage.vue?vue&type=script&lang=ts"
export * from "./FeedbackPage.vue?vue&type=script&lang=ts"
script.render = render

export default script